var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhaatsProp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 512,
    viewBox: "0 0 513 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6388_153)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.646 285.93C307.956 289.89 301.766 305.06 295.486 312.81C292.266 316.78 288.426 317.4 283.476 315.41C247.106 300.92 219.226 276.65 199.156 243.18C195.756 237.99 196.366 233.89 200.466 229.07C206.526 221.93 214.146 213.82 215.786 204.2C219.426 182.92 191.606 116.91 154.866 146.82C49.1461 232.97 331.226 461.46 382.136 337.88C396.536 302.85 333.706 279.35 317.646 285.93ZM256.526 467.28C219.136 467.28 182.346 457.34 150.136 438.52C144.966 435.49 138.716 434.69 132.936 436.26L62.9461 455.47L87.3261 401.76C90.6461 394.45 89.7961 385.94 85.1061 379.44C59.0261 343.29 45.2361 300.61 45.2361 256C45.2361 139.49 140.016 44.71 256.526 44.71C373.036 44.71 467.806 139.49 467.806 256C467.806 372.5 373.026 467.28 256.526 467.28ZM256.526 0C115.366 0 0.526114 114.84 0.526114 256C0.526114 305.66 14.6261 353.35 41.4161 394.74L2.52611 480.39C-1.06389 488.3 0.246114 497.56 5.86611 504.15C10.1861 509.2 16.4361 512 22.8861 512C37.3061 512 115.936 487.29 135.946 481.8C172.936 501.59 214.426 512 256.526 512C397.676 512 512.526 397.15 512.526 256C512.526 114.84 397.676 0 256.526 0Z",
    fill: "#39AE41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6388_153"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white",
    transform: "translate(0.523438)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhaatsProp);
export default __webpack_public_path__ + "static/media/whaats-prop.a784f8388dea834992765d2d0535f58c.svg";
export { ForwardRef as ReactComponent };